export default __webpack_public_path__ + "static/media/oral-5.9c3e1811.png";